module.exports = __webpack_public_path__ + "static/media/key-skeleton-alt.b78d1db8.svg";